var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import propTypes from 'prop-types';
import { PERMISSION_LEVEL_READ_ACCESS } from '../constants/permissionLevels';
import { checkAccess } from '../helpers/menuHelpers';
var AreaAwareItem = function (_a) {
    var user = _a.user, area = _a.area, rest = __rest(_a, ["user", "area"]);
    var level = PERMISSION_LEVEL_READ_ACCESS;
    if (rest.hasOwnProperty('level') && rest.level !== null) {
        level = rest.level;
    }
    if (checkAccess(user, area, level)) {
        return rest.children;
    }
    else {
        return null;
    }
};
AreaAwareItem.propTypes = {
    user: propTypes.object.isRequired,
    area: propTypes.string.isRequired,
    children: propTypes.element.isRequired,
    level: propTypes.number,
};
export default AreaAwareItem;
